import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Hero from './Hero';
import SignupBanner from './SignupBanner';
import ValueProposition from './ValueProposition';
import Features from './Features';
import SampleReport from './SampleReport';
import PricingSection from './PricingSection';
import Regulations from './Regulations';
import FAQ from './FAQ';
import CTASection from './CTASection';
import Footer from './Footer';
import './LandingPage.css';

const LandingPage = () => {
  const { i18n } = useTranslation();
  const isKo = i18n.language === 'ko';

  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem('theme') || 'dark'; } catch (e) { return 'dark'; }
  });

  useEffect(() => {
    try { localStorage.setItem('theme', theme); } catch (e) { /* noop */ }
  }, [theme]);

  const toggleLocale = (lang) => {
    i18n.changeLanguage(lang);
  };

  const toggleTheme = () => setTheme((t) => (t === 'light' ? 'dark' : 'light'));
  const isLight = theme === 'light';

  return (
    <div className={`landing-page${isLight ? ' lp-light' : ''}`}>
      <nav className="landing-nav">
        <div className="wrap nav-inner">
          <div className="brand">
            <span>VERIPASS</span>
          </div>
          <div className="nav-links">
            <a href="#features">{isKo ? '기능' : 'Features'}</a>
            <a href="#pricing">{isKo ? '가격' : 'Pricing'}</a>
            <a href="#faq">FAQ</a>
          </div>
          <div className="nav-actions">
            <div className="locale-toggle">
              <span className={isKo ? 'active' : ''} onClick={() => toggleLocale('ko')}>KR</span>
              <span className={!isKo ? 'active' : ''} onClick={() => toggleLocale('en')}>EN</span>
            </div>
            <button
              type="button"
              className="lp-theme-toggle"
              onClick={toggleTheme}
              aria-label={isLight
                ? (isKo ? '다크 모드로 전환' : 'Switch to dark mode')
                : (isKo ? '라이트 모드로 전환' : 'Switch to light mode')}
              aria-pressed={isLight}
            >
              <span className="material-symbols-outlined" aria-hidden="true">
                {isLight ? 'dark_mode' : 'light_mode'}
              </span>
            </button>
            <a href="/login">{isKo ? '로그인' : 'Login'}</a>
            <a className="btn btn-primary" href="/login?signup=true">{isKo ? '시작하기' : 'Start'}</a>
          </div>
        </div>
      </nav>

      <Hero />
      <SignupBanner />
      <ValueProposition />
      <Features />
      <SampleReport />
      <PricingSection />
      <Regulations />
      <FAQ />
      <CTASection />
      <Footer />
    </div>
  );
};

export default LandingPage;
